export default __webpack_public_path__ + "static/media/eshel2.342921cf.jpg";